import { Layout } from 'react-grid-layout';

export const parseWorkspaceLayoutSizes = (layout: Layout[]) => {
  return layout.reduce(
    (accumulator, { i, w, h }) => ({
      ...accumulator,
      [i]: { w, h },
    }),
    {},
  );
};
